import { ReactElement, useEffect, useState, useContext } from 'react';
import { ComparisonContext } from 'context/ProductComparisonContext';
import Link from '../Link';
import { useRouter } from 'next/router';

export default function CompareButton(): ReactElement {
  const [right, setRight] = useState(0);
  const router = useRouter();
  const { selected } = useContext(ComparisonContext);
  const frameQuery = `${selected
    ?.map((item, i) => `${i !== 0 ? '&' : ''}frame=${item.productId}:${item.sku}`)
    .join('')}`;
  const query = frameQuery + `&from=${encodeURIComponent(router.asPath)}`;

  useEffect(() => {
    function updatePosition(): void {
      const width = window.innerWidth;
      const position =
        width > 1440
          ? (width - 1440) / 2 + 40 // right edge of container
          : 40;

      setRight(position);
    }

    window.addEventListener('resize', updatePosition);
    updatePosition();
    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return selected && selected?.length >= 2 ? (
    <Link slug="/shop/compare" query={query}>
      <a
        className="fixed rounded-full px-12 py-4 font-semibold whitespace-no-wrap text-sm text-tertiary bg-tertiary shadow-lg z-50"
        style={{ right: right, bottom: 40 }}
        aria-label={`compare ${selected.length} frames`}
      >
        {`Compare ${selected?.length}/4 Frames`}
      </a>
    </Link>
  ) : (
    <></>
  );
}
